
import { Component, Vue } from 'vue-property-decorator';

import Trail from './Trail.vue'
import FormIcon from './journeyicons/FormIcon.vue'
import ReturnTrail from './ReturnTrail.vue'
import CalendarIcon from './journeyicons/CalendarIcon.vue'
import GavelIcon from './journeyicons/GavelIcon.vue'
import EndCircle from './journeyicons/EndCircle.vue'

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';

import InitialDocumentsAppRightToAppealPg from '../components/AppRightToAppeal/InitialDocumentsAppRightToAppealPg.vue';
import ApplyLeaveAppRightToAppealPg from '../components/AppRightToAppeal/ApplyLeaveAppRightToAppealPg.vue';
import AppealRecordTranscriptAppRightToAppealPg from '../components/AppRightToAppeal/AppealRecordTranscriptAppRightToAppealPg.vue';
import FactumAppealBookAppRightToAppealPg from '../components/AppRightToAppeal/FactumAppealBookAppRightToAppealPg.vue';
import BookAppealDateAppRightToAppealPg from '../components/AppRightToAppeal/BookAppealDateAppRightToAppealPg.vue';
import NoticeOfHearingAppRightToAppealPg from '../components/AppRightToAppeal/NoticeOfHearingAppRightToAppealPg.vue';
import BookOfAuthoritiesAppRightToAppealPg from '../components/AppRightToAppeal/BookOfAuthoritiesAppRightToAppealPg.vue';

import TheHearingAppRightToAppealPg from '../components/AppRightToAppeal/TheHearingAppRightToAppealPg.vue';
import OrdersAppRightToAppealPg from '../components/AppRightToAppeal/OrdersAppRightToAppealPg.vue';
import AppealProcessCompleteAppRightToAppealPg from '../components/AppRightToAppeal/AppealProcessCompleteAppRightToAppealPg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        ReturnTrail,
        CalendarIcon,
        GavelIcon,
        EndCircle,
        InstructionWindowFooter,
        PathSidebar,  
        InitialDocumentsAppRightToAppealPg,
        ApplyLeaveAppRightToAppealPg,
        AppealRecordTranscriptAppRightToAppealPg,
        FactumAppealBookAppRightToAppealPg,
        BookAppealDateAppRightToAppealPg,
        NoticeOfHearingAppRightToAppealPg,
        BookOfAuthoritiesAppRightToAppealPg,
        TheHearingAppRightToAppealPg,
        OrdersAppRightToAppealPg,
        AppealProcessCompleteAppRightToAppealPg
    }
})
export default class AppellantRightToAppealJourneyMap extends Vue {
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []

    showWindow = false;
    windowTitle = '';
    contentTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];
    initialDocumentsContent = false;
    applyForLeaveToAppealContent = false;
    appealRecordTranscriptContent = false;
    factumAppealBookContent = false;
    bookAppealDateContent = false;
    noticeOfHearingContent = false;
    bookOfAuthoritiesContent = false;
    theHearingContent = false;
    courtOrderContent = false;
    appealProcessCompleteContent = false; 
    updated=0;

    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.APP_RIGHT_TO_APPEAL._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.APP_RIGHT_TO_APPEAL).length-1;
        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)        
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public adjustHeights(index: number, pathHeight: string){       
        this.updated++;
        this.pathHeights[index] = pathHeight;
    }

    public showOrders(){
        this.showWindow = false;
        this.displayWindow('Final Order and Costs');
    }

    public displayWindow(contentType: string){

        this.contentTitle = '';
        this.initialDocumentsContent = false;
        this.applyForLeaveToAppealContent = false;
        this.appealRecordTranscriptContent = false;        
        this.factumAppealBookContent = false;
        this.bookAppealDateContent = false;
        this.noticeOfHearingContent = false;
        this.bookOfAuthoritiesContent = false;
        this.theHearingContent = false;
        this.courtOrderContent = false;
        this.appealProcessCompleteContent = false; 

        if (contentType == "Initial Document"){
            this.contentTitle = 'Would you like to start your appeal?';
            this.windowTitle = "Initial Document";
            this.pathTypes = ["share"];
            this.pathHeights = ['18rem'];
            this.initialDocumentsContent = true;

        } else if (contentType == "If Leave required") {

            this.windowTitle = "If Leave required";
            this.pathTypes = ["info", "share", "share", "share"];
            this.pathHeights = ['16.5rem', '0', '0', '0'];
            this.applyForLeaveToAppealContent = true;

        } else if (contentType == "Appeal Record and Transcript"){

            this.windowTitle = "Appeal Record and Transcript";
            this.pathTypes = ["share"];
            this.pathHeights = ['33rem'];
            // this.pathTypes = ["share", "info"];
            // this.pathHeights = ['33rem', '0'];
            this.appealRecordTranscriptContent = true;

        } else if (contentType == "Factums and Appeal Book"){

            this.windowTitle = "Factums and Appeal Book";
            this.pathTypes = ["share", "share", "info"];
            this.pathHeights = ['54.75rem', '0', '0'];
            // this.pathTypes = ["share", "share", "info", "info"];
            // this.pathHeights = ['56rem', '0', '0', '0'];
            this.factumAppealBookContent = true;

        } else if (contentType == "Book Appeal Date"){

            this.windowTitle = "Book Appeal Date";
            this.pathTypes = ["gavel", "info"];
            this.pathHeights = ['7rem', '0'];
            // this.pathTypes = ["gavel", "info", "info"];
            // this.pathHeights = ['7rem', '0', '0'];
            this.bookAppealDateContent = true;

        } else if (contentType == "Notice of Hearing"){

            this.windowTitle = "Notice of Hearing";
            this.pathTypes = ["question", "share"];
            this.pathHeights = ['31rem', '0'];
            this.noticeOfHearingContent = true;

        } else if (contentType == "Book of Authorities"){            
            this.windowTitle = "Book of Authorities";
            this.pathTypes = ["info", "share"];
            this.pathHeights = ['26rem', '0'];            
            this.bookOfAuthoritiesContent = true;

        } else if (contentType == "The Hearing"){
            this.contentTitle = "For more information about the hearing process, click the topics below:";
            this.windowTitle = "The Hearing";
            this.pathTypes = ["gavel", "share"];
            this.pathHeights = ['5rem', '0'];
            // this.pathTypes = ["gavel", "share", "share", "info"];
            // this.pathHeights = ['5rem', '0', '0', '0'];
            this.theHearingContent = true;

        } else if (contentType == "Final Order and Costs"){

            this.windowTitle = "Final Order and Costs";
            this.pathTypes = ["info", "info", "share", "info"];
            this.pathHeights = ['21rem', '0', '0', '0'];
            this.courtOrderContent = true;

        } else if (contentType == "Appeal Process Complete"){

            this.windowTitle = "Appeal Process Complete";
            this.pathTypes = ["info"];
            this.pathHeights = ['3rem'];
            this.appealProcessCompleteContent = true;
        }
        this.showWindow = true; 
    }
}
